import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useServiceLog');

    return {
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
